import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Query } from "react-apollo";
import gql from "graphql-tag";
import { ApolloError } from "apollo-client";

import { useStateValue } from "../Store";

import { listTings } from "../graphql/queries";
import { ItemLayout } from "../components/ItemLayout";
import { Feed } from "../components/Feed";
import { TingAction } from "../components/TingAction";
import { useQueryVars } from "../hooks/useQueryVars";
import { LoadingFeed } from "../components/LoadingFeed";
import { HorizontalMenu } from "../components/HorizontalMenu";

export const AllContainer = () => {
  //@ts-ignore
  // eslint-disable-next-line
  const [store, dispatch] = useStateValue();
  const queryVars = useQueryVars("ALL");

  return (
    <div className="md:max-w-2xl md:mx-auto relative z-10">
      <HorizontalMenu />
      <Query query={gql(listTings)} variables={queryVars}>
        {({
          loading,
          error,
          data,
        }: {
          loading: boolean;
          error?: ApolloError | undefined;
          data: any;
        }) => {
          if (loading) return <LoadingFeed />;
          if (error) return <ItemLayout>`Error! ${error.message}`</ItemLayout>;
          return (
            <div className="pt-5 pb-10">
              <ItemLayout className="ting-header">All</ItemLayout>
              <Feed id={undefined} tings={data.listTings.items} />
              {!store.selected && (
                <TingAction referenceID={undefined} reference={undefined} />
              )}
            </div>
          );
        }}
      </Query>
    </div>
  );
};
